import { ERoles } from '@/auth/constants';
import { BackkdropLoader } from '@/components/backdroploader';
import { PermWrapper } from '@/components/permwrapper';
import { Unauthorized } from '@/components/unauthorized';
import React from 'react';
import { Suspense } from 'react';
import { Route } from 'react-router-dom';

const ProxyPhones = React.lazy(() => import('@/views/sync/proxyphones/main'));

export const SyncRoutes = (
	<>
		<Route
			path='/sync/proxyphones'
			element={
				<Suspense fallback={<BackkdropLoader />}>
					<PermWrapper
						allowedRoles={[ERoles.ADMIN]}
						fallback={<Unauthorized />}>
						<ProxyPhones />
					</PermWrapper>
				</Suspense>
			}
		/>
	</>
);
